import moment from "moment";
import { Cell } from "react-table";
import DetailLink from "src/components/DetailLink";
import PagePath from "src/pagePath.json";
import { ViewYmdFormat, YmdFormat, numberToStringWithComma } from "src/utils";
import { findPriceRuleOptionToText, findPriceRuleToText, formatDayOfWeekList } from "../../price-types";
import BaseNewTabLink from "src/components/BaseNewTabLink";
import { BaseTooltip } from "src/components";
import { PriceRules } from "src/api/price/price-types";
import _ from "lodash";

/* 
  공용공간 예약 목록 columns
*/
const priceListColumn = [
  {
    Header: "공용공간 요금 ID",
    accessor: "id",
    width: 160,
    Cell: (props: Cell<any>) => {
      const detailPath = `${PagePath.price.detail.replace(":id", `${props.value}`)}`;
      return (
        <div>
          <DetailLink className="text-underline" to={`${detailPath}`}>
            {props.value}
          </DetailLink>
        </div>
      );
    },
  },
  {
    Header: "요금 정책명",
    accessor: "name",
    width: 160,
    Cell: ({ value }: Cell<any>) => {
      return (
        <div className="w-100 text-left ellipsis2">
          <p>{value || "-"}</p>
        </div>
      );
    },
  },
  {
    // Header: "",
    Header: () => {
      return <p className="no-wrap">판매단가(원/30분)</p>;
    },
    accessor: "price",
    width: 130,
    Cell: ({ value }: Cell<any>) => {
      return (
        <div className="w-100 text-right">
          <p>{value.toString() === "0" ? "무료" : numberToStringWithComma(value)}</p>
        </div>
      );
    },
  },
  {
    Header: () => {
      return <p className="no-wrap">원가단가(원/30분)</p>;
    },
    accessor: "cost",
    width: 130,
    Cell: ({ value }: Cell<any>) => {
      return (
        <div className="w-100 text-right">
          <p>{numberToStringWithComma(value)}</p>
        </div>
      );
    },
  },
  {
    Header: "프로바이더",
    accessor: "providerName",
    width: 240,
    Cell: (props: Cell<any>) => {
      return <BaseTooltip className="w-100 text-left" contents={props.value || "-"} />;
    },
  },
  {
    Header: () => {
      return <p className="no-wrap">요금유형</p>;
    },
    accessor: "priceRuleType",
    width: 80,
    Cell: ({ value }: Cell<any>) => {
      return <p className="w-100 text-center">{findPriceRuleToText(value)}</p>;
    },
  },


  {
    Header: "적용 대상",
    accessor: "facility",
    width: 120,
    Cell: ({ row }: Cell<any>) => {
      const ruleType = row.original.priceRuleType;
      const facility = row.original.facilityName;
      return (
        <div className="text-left w-100 ">
          {ruleType === PriceRules.PRICE_RULE_PROVIDER ? (
            <p className="w-100 text-left">전체 공용공간</p>
          ) : ruleType === PriceRules.PRICE_RULE_FACILITY ? (
            <BaseTooltip className="w-100 text-left" contents={facility || "-"} />
          ) : (
            "-"
          )}
        </div>
      );
    },
  },
  {
    Header: "적용 시작일",
    accessor: "startDate",
    width: 120,
    Cell: ({ row }: Cell<any>) => {
      const start = moment(row.original.startDate).format(ViewYmdFormat.YYYY_MM_DD);
      return <p className="w-100 text-center">{row.original.startDate ? start : "-"}</p>;
    },
  },
  {
    Header: "적용 종료일",
    accessor: "endDate",
    width: 120,
    Cell: ({ row }: Cell<any>) => {
      const end = moment(row.original.endDate).format(ViewYmdFormat.YYYY_MM_DD);
      return <p className="w-100 text-center">{row.original.endDate ? end : "-"}</p>;
    },
  },
  {
    Header: "적용 요일",
    accessor: "dayOfWeekList",
    width: 120,
    Cell: ({ value }: Cell<any>) => {
      return <p>{formatDayOfWeekList(value)}</p>;
    },
  },
  {
    Header: "적용 시간",
    accessor: "endTime",
    width: 120,
    Cell: (props: Cell<any>) => {
      return <p>{props.row.original.startTime ? props.row.original.startTime + " ~ " + props.value : "-"}</p>;
    },
  },

  {
    Header: "최종 수정일시",
    accessor: "modifiedDate",
    Cell: (props: Cell<any>) => <p className="w-100 text-center">{props?.value ? moment(props?.value).format(YmdFormat.FULL) : '-'}</p>,
    width: 160,
  },
];

export default priceListColumn;
